import { AemSiteWideMessageQuery } from '@src/queries/AEMSitewideMessageQuery.generated'

export enum CtaType {
  PushNotifications = 'PushNotifications',
}
export type DynamicSiteWideMessage =
  AemSiteWideMessageQuery['aemSiteWideMessages'][number] & {
    ctaType?: CtaType
  }
export type SystemMessage = Omit<DynamicSiteWideMessage, 'priority'> & {
  priority: 'System'
}
export type AnySiteWideMessage = DynamicSiteWideMessage | SystemMessage
